export default __webpack_public_path__ + "static/media/coeur.68327a80.png";